const baseMdcBlockGroup = require('./_BaseMdcBlockGroup');
const Blockly = require('blockly');

class NavHeadings extends baseMdcBlockGroup {
    addCodeGeneratorCustom(code, blocklyBlock, hNodeType) {
        if (hNodeType === 'TabNavHeading') code.isTabContainer = true;

        code.iconName = blocklyBlock.getFieldValue('iconName');
        code.iconColor = blocklyBlock.getFieldValue('iconColor');

        return JSON.stringify(code);
    }
    addToBlocksCustom(color, blocklyBlock, hNodeType) {
        blocklyBlock.setPreviousStatement(false);
        blocklyBlock.setNextStatement(false);
        blocklyBlock
            .appendDummyInput()
            .setAlign(Blockly.ALIGN_RIGHT)
            .appendField('  Icon Name:')
            .appendField(new Blockly.FieldTextInput(''), 'iconName')
            .appendField('  Icon Color:')
            .appendField(new Blockly.FieldTextInput(''), 'iconColor');
    }
}

module.exports = NavHeadings;
